











































import { computed, defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api';
import useBrandContent from '@shared/composables/useBrandContent';
import useShopifyProduct from '@shared/composables/useShopifyProduct';
import useSizeGuide from '@shared/composables/useSizeGuide';
import { lockPageScrollOnMobileOnly } from '@shared/composables/useUiHelpers/lockPageScroll';
import { unlockPageScrollOnMobileOnly } from '@shared/composables/useUiHelpers/unlockPageScroll';
import { ProductCollection } from '@shared/types/ProductViewModel';
import { BaseModal, UCButton, UCIcon } from '@shared/ui';

import { BRAND_DISCLAIMER, GENERIC_DISCLAIMER, REFUNDS_BLURB, REFUNDS_TITLE } from './constants';
import SizeGuideMeasurementGuide from './SizeGuideMeasurementGuide.vue';
import SizeGuideTable from './SizeGuideTable.vue';

export default defineComponent({
  name: 'SizeGuide',
  components: {
    SizeGuideTable,
    SizeGuideMeasurementGuide,
    BaseModal,
    UCIcon,
    UCButton,
  },
  props: {
    vendor: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    collections: {
      type: Array as PropType<ProductCollection[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { product } = useShopifyProduct();
    const { brand } = useBrandContent();
    const isHidden = ref(true);
    const modalOpen = ref(false);

    const setModalOpen = (value: boolean) => (modalOpen.value = value);

    const { id, collections } = product;
    const { logoSrc } = brand;

    const { sizeGuide } = useSizeGuide({
      productId: props.productId || id.value,
      categoryHandles: (props.collections ?? collections.value ?? []).map(({ slug }) => slug),
    });

    const isBrandSpecific = computed(() => {
      return !!sizeGuide.value?.brand || !!sizeGuide.value?.product?.length;
    });

    watch(sizeGuide, (val) => {
      if (val?.component === 'SizeGuide') {
        isHidden.value = false;
      }
    });

    watch(modalOpen, (isOpen) => {
      if (isOpen) {
        lockPageScrollOnMobileOnly();
      } else {
        unlockPageScrollOnMobileOnly();
      }
    });

    return {
      isHidden,
      sizeGuide,
      modalOpen,
      setModalOpen,
      BRAND_DISCLAIMER,
      GENERIC_DISCLAIMER,
      REFUNDS_TITLE,
      REFUNDS_BLURB,
      isBrandSpecific,
      logoSrc,
    };
  },
});
